import type { ApiV1, PermissionRule } from '@teamworksdev/influencer/core';

/**
 * Checks if a user profile meets a specific permission rule requirement.
 *
 * @param profile - The user profile to check permissions against. If undefined, the check will fail.
 * @param rule - The permission rule to evaluate against the profile.
 * @returns Boolean indicating whether the profile meets the permission requirements.
 */
export function checkPermission(
	profile: ApiV1.FullUserProfile | undefined,
	rule: PermissionRule,
): boolean {
	if (!profile) return false;
	return Boolean(rule.check(profile));
};
